import React from 'react';

interface SectionBoxProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'gray' | 'blue' | 'green';
  type?: 'child' | 'parent';
}

export const SectionBox: React.FC<SectionBoxProps> = ({
  children,
  className = '',
  variant = 'gray',
  type = 'child',
}) => {
  const variantClasses = {
    gray: 'border-gray-300 dark:border-white/15',
    blue: 'border-blue-300 dark:border-blue-700/30',
    green: 'border-green-400 dark:border-green-700/30',
  };

  const backgroundClasses = {
    gray: 'bg-gray-50 dark:bg-white/5',
    blue: 'bg-blue-50 dark:bg-blue-900/20',
    green: 'bg-green-50 dark:bg-green-900/20',
  };

  if (type === 'child') {
    return (
      <div className={`space-y-4 border-l-4 ${variantClasses[variant]} ml-6 pl-4 ${className}`}>
        {children}
      </div>
    );
  }

  return (
    <div
      className={`space-y-4 ${backgroundClasses[variant]} border ${variantClasses[variant]} p-6 rounded-lg ${className}`}
    >
      {children}
    </div>
  );
};
